module.exports = __webpack_public_path__ + "img/cv.986a7f10.png";